// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"454eadff","774":"e8779b72","858":"6ab78fa5","899":"ade39d1a","916":"49e4618d"}[chunkId] + ".chunk.js";
};